import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteBanner, getBannerList } from "../action";
import { getBannerFilter } from "../selectors";

export const useDeleteBanner = ({ id }) => {
  const dispatch = useDispatch();
  const filter = useSelector(getBannerFilter);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [deleteBannerLoading, setDeleteBannerLoading] =
    useState(false);

  const handleDeleteBanner = async () => {
    setDeleteBannerLoading(true);
    const is_success = await dispatch(deleteBanner(id));
    setDeleteBannerLoading(false);
    if (is_success) {
      dispatch(getBannerList(filter));
      toggleModal();
    }
  };

  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  return {
    deleteBannerLoading,
    handleDeleteBanner,
    isOpenModal,
    toggleModal,
  };
};
